import React from 'react';
import '../styles/Warning.css';

export default function Warning({display, text}) {
    return (
        <div className="warning" style={{display: display?"flex":"none"}}>
            <svg height="24" fill='rgb(175, 4, 4)' viewBox="0 0 24 24" width="24"><path clipRule="evenodd" d="M16.336 18H7.003c-1.51 0-2.475-1.609-1.765-2.941l4.667-8.75c.753-1.412 2.776-1.412 3.53 0l4.666 8.75c.71 1.332-.255 2.94-1.765 2.94zM11.67 8.5a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1zm0 7.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" fillRule="evenodd"></path></svg>
            <p>
                {
                    text
                    ?
                    text
                    :
                    "Please fill this in"
                }
            </p>
        </div>
    )
}